import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsService } from '../../services/contactus.service';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {

  contactForm!: FormGroup;

  isSubmitting = false;
  submitSuccess = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private contactUsService: ContactUsService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[A-Za-z]+( [A-Za-z]+)*$')]],
      mobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      email: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{3,4}$')]],
      company: ['', [Validators.required, Validators.pattern('^[A-Za-z]+( [A-Za-z]+)*$')]],
      reason: ['', [Validators.required, Validators.pattern('^[A-Za-z]+( [A-Za-z]+)*$')]]
    });
  }

  onSubmit(): void {

    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';

    const payload = {
      FullName: this.contactForm.value.name,
      MobileNumber: this.contactForm.value.mobile,
      Email: this.contactForm.value.email,
      CompanyName: this.contactForm.value.company,
      Reason: this.contactForm.value.reason
    };

    this.contactUsService.sendContactUsEmail(payload).subscribe({
      next: (response: any) => {
        this.isSubmitting = false;

        if (response && !response.IsError) {
          this.submitSuccess = true;
        } else {
          this.errorMessage = response?.Message || 'Something went wrong. Please try again.';
        }
      },
      error: (error) => {
        this.isSubmitting = false;
        this.errorMessage = 'Server error. Please check your connection.';
        console.error('Contact Us Error:', error);
      }
    });
  }

  close(): void {
    this.activeModal.dismiss();
  }

  get f() {
    return this.contactForm.controls;
  }
}
